import {
  FETCH_REFERRAL_PROGRAMS,
  FETCH_REFERRAL_PROGRAMS_LOADING,
  FETCH_REFERRAL_PROGRAMS_ERROR,
  FETCH_REFERRAL_PROGRAM_BY_ID,
  FETCH_REFERRAL_PROGRAM_BY_ID_LOADING,
  FETCH_REFERRAL_PROGRAM_BY_ID_ERROR,
  SET_FILTERS,
  RESET_FILTERS,
  SET_SORT_PARAMS,
  SET_PAGINATION,
  RESET_PAGINATION
} from './ReferralProgram.constants';
import { IReferralProgramState, IAction } from './ReferralProgram.types';

const defaultState: IReferralProgramState = {
  totalProgramsCount: 0,
  filteredPrograms: [],
  searchResults: [],
  selectedProgram: null,
  isLoading: false,
  isLoadingMore: false,
  isSearchLoading: false,
  isFetchByIdLoading: false,
  errorMessage: null,
  searchErrorMessage: null,
  fetchByIdErrorMessage: null,
  appliedFilters: {},
  sortParams: {
    sortBy: 'created_at',
    descendingOrder: true
  },
  pagination: {
    pageNumber: 1,
    limit: 20,
  },
  fetchedCount: 0,
  isNextPresent: false,
};

export default function referralProgramReducer(state = defaultState, action: IAction) {
  switch (action.type) {
    case FETCH_REFERRAL_PROGRAMS:
      return {
        ...state,
        totalProgramsCount: action.totalProgramsCount ?? state.totalProgramsCount,
        filteredPrograms: action.isLoadMore ? [...state.filteredPrograms, ...action.data] : action.data,
        errorMessage: null,
        fetchedCount: action.fetchedCount || 0,
        isNextPresent: action.isNextPresent ?? false,
        pagination: {
          ...state.pagination,
          ...(action.pagination || {}),
        }
      };

    case FETCH_REFERRAL_PROGRAMS_LOADING:
      return {
        ...state,
        isLoading: action.isLoadMore ? false : action.data,
        isLoadingMore: action.isLoadMore ? action.data : false
      };

    case FETCH_REFERRAL_PROGRAMS_ERROR:
      return { ...state, errorMessage: action.error };

    case FETCH_REFERRAL_PROGRAM_BY_ID:
      return { ...state, selectedProgram: action.data, fetchByIdErrorMessage: null };

    case FETCH_REFERRAL_PROGRAM_BY_ID_LOADING:
      return {
        ...state,
        isFetchByIdLoading: action.isLoading,
        selectedProgram: action.data || state.selectedProgram,
      };

    case FETCH_REFERRAL_PROGRAM_BY_ID_ERROR:
      return { ...state, fetchByIdErrorMessage: action.error };

    case SET_FILTERS:
      return { ...state, appliedFilters: action.filters };

    case RESET_FILTERS:
      return { ...state, appliedFilters: {} };

    case SET_SORT_PARAMS:
      return { ...state, sortParams: { ...state.sortParams, ...action.sortParams } };

    case SET_PAGINATION:
      return { ...state, pagination: { ...state.pagination, ...action.pagination } };

    case RESET_PAGINATION:
      return { ...state, pagination: defaultState.pagination };

    default:
      return state;
  }
}